import React, { FunctionComponent, useState } from "react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	makeStyles,
	MenuItem,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import SummaryPatientHeader from "../OrderHistory/OrderTable/SummaryPatientHeader";
import { colors } from "@bg/shared/lib/theme";
import { Cancel } from "@material-ui/icons";
import { PrimaryButton, SecondaryButton } from "@bg/shared/lib/components";

const useStyles = makeStyles({
	root: {
		"& .MuiInputBase-input": {
			backgroundColor: colors.white
		}
	},
	buttonContainer: {
		paddingTop: ".75em",
		paddingBottom: ".75em",
		width: "780px",
		backgroundColor: colors.grey
	},
	floatRight: {
		float: "right",
	},
	redColor: {
		color: colors.candyRed,
	},
	trackingInputField: {
		width: "7.7rem",
		paddingRight: "10px",
	},
	dialogContentFields: {
		display: "flex",
		alignItems: "center",
	},
	bottomBtnContainer: {
		backgroundColor: colors.grey,
	}
});

interface ShippingTrackingDialogProps {
	saveTrackingNumber: (
		carrier: string,
		trackingNo: string,
		sampleId: number
	) => Promise<any>;
	orderInfo: SummaryPatientHeader;
	openDialog: boolean;
	closeDialog: () => void;
}

const ShippingTrackingDialog: FunctionComponent<
	ShippingTrackingDialogProps
> = ({ saveTrackingNumber, orderInfo, openDialog, closeDialog }) => {
	const [carrier, setCarrier] = useState("");
	const [trackingNo, setTrackingNo] = useState("");
	const classes = useStyles();
	const handleTrackingNumberSave = () => {
		if (orderInfo && orderInfo.id) {
			saveTrackingNumber(carrier, trackingNo, parseInt(orderInfo.id));
		}
	};

	return (
		<Dialog open={openDialog} maxWidth="lg">
			<div className={classes.buttonContainer}>
				<Button className={classes.floatRight} onClick={closeDialog}>
					<Cancel className={classes.redColor} fontSize="medium" />
				</Button>
				<DialogTitle id="form-dialog-title">Enter Tracking Number</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Please enter your tracking number and carrier
					</DialogContentText>
					<div className={classes.dialogContentFields}>
						<div>
							<TextField
								className={classes.trackingInputField}
								classes={{root: classes.root}}
								value={carrier}
								onChange={(e) => setCarrier(e.target.value)}
								select // tell TextField to render select
								label="Carrier"
							>
								<MenuItem value={"Fedex"}>Fedex</MenuItem>
								<MenuItem value={"USPS"}>USPS</MenuItem>
							</TextField>
						</div>
						<div>
							<TextField
								autoFocus
								classes={{root: classes.root}}
								id="name"
								label="Tracking #"
								type="string"
								onChange={(e) => setTrackingNo(e.target.value)}
								fullWidth
							/>
						</div>
					</div>
				</DialogContent>
			</div>
			<DialogActions className={classes.bottomBtnContainer}>
				<SecondaryButton onClick={closeDialog}>
					Close
				</SecondaryButton>
				<PrimaryButton
					onClick={handleTrackingNumberSave}>
					Save
				</PrimaryButton>
			</DialogActions>
		</Dialog>
	);
};

export default ShippingTrackingDialog;
